module.exports = __webpack_public_path__ + "static/media/info01_L.072f31c1.png";